import { useState, useEffect, useMemo } from "react";
import logger from "../../util/logger";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db } from "../../util/firebase";
import {
  query,
  collection,
  getDocs,
  where,
  doc,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import Swal from "sweetalert2";

import { useNavigate } from "react-router-dom";

import classnames from "classnames";

import { ScrollMenu } from "react-horizontal-scrolling-menu";
import "react-horizontal-scrolling-menu/dist/styles.css";

import BarLoader from "react-spinners/BarLoader";

// import {FaChevronLeft} from 'react-icons/fa';
import { Button } from "reactstrap";

import { DataGridPro, GridToolbar } from "@mui/x-data-grid-pro";

function AdminPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("USERS");
  const toggleActiveTab = (tab) => {
    setActiveTab(tab);
    // if (tab === activeTab){
    //   setActiveTab();
    // } else {
    //   setActiveTab(tab);
    // }
  };

  const [users, setUsers] = useState();
  const fetchUsers = async () => {
    try {
      setIsLoading(true);

      let fetchedUsers = [];

      const q = query(collection(db, "users"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newUser = doc.data();

        if (
          newUser.username &&
          !fetchedUsers.some((u) => u.username === newUser.username)
        ) {
          fetchedUsers.push(newUser);
        }
      });

      logger.debug(fetchedUsers);

      // Sort users by dateCreated: newest first. Users without dateCreated go last.
      fetchedUsers.sort((a, b) => {
        const getDate = (u) => {
          if (!u) return null;
          const d = u.dateCreated;
          if (!d) return null;
          try {
            if (
              typeof d === "object" &&
              d !== null &&
              typeof d.toDate === "function"
            ) {
              return d.toDate();
            }
            if (
              typeof d === "object" &&
              d !== null &&
              typeof d.seconds === "number"
            ) {
              return new Date(d.seconds * 1000);
            }
            return new Date(d);
          } catch (e) {
            return null;
          }
        };

        const da = getDate(a);
        const db = getDate(b);

        if (da && db) return db - da; // newest first
        if (da && !db) return -1; // a has date, b doesn't -> a first
        if (!da && db) return 1; // b has date, a doesn't -> b first
        return 0; // both missing -> keep relative order
      });

      setUsers(fetchedUsers);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching users");
    }
  };
  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line
  }, []);

  const [groups, setGroups] = useState();
  const fetchGroups = async () => {
    try {
      setIsLoading(true);

      let fetchedGroups = [];

      const q = query(collection(db, "groups"));
      const docs = await getDocs(q);

      docs.forEach((doc) => {
        const newGroup = doc.data();

        let areResultsIn = true;

        // Check for Racing/Formula 1 groups (drivers-based)
        if (newGroup.drivers && Array.isArray(newGroup.drivers)) {
          // For racing groups, check if ALL drivers have results
          if (newGroup.drivers.length === 0) {
            areResultsIn = false;
          } else {
            areResultsIn = newGroup.drivers.every((driver) => driver.result);
          }
        } else {
          // For event-based groups (e.g., other sports)
          newGroup.events?.forEach((event) => {
            if (!event.result) {
              areResultsIn = false;
            }
          });
        }

        if (areResultsIn) {
          newGroup.results = "Submitted";
        } else {
          newGroup.results = "Pending";
        }

        fetchedGroups.push(newGroup);
      });

      fetchedGroups.sort((a, b) => {
        return new Date(b.openingDateTime) - new Date(a.openingDateTime);
      });

      setGroups(fetchedGroups);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching groups");
    }
  };
  useEffect(() => {
    fetchGroups();
    // eslint-disable-next-line
  }, []);

  const [rooms, setRooms] = useState();
  const fetchRooms = async () => {
    try {
      setIsLoading(true);

      let fetchedRooms = [];

      const q = query(collection(db, "rooms"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newRoom = doc.data();
        newRoom.memberCount = newRoom.members?.length;
        newRoom.status = newRoom.isActive ? "Active" : "Inactive";
        fetchedRooms.push(newRoom);
      });

      fetchedRooms.sort((a, b) => {
        return parseInt(a.uid) - parseInt(b.uid);
      });

      setRooms(fetchedRooms);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching rooms");
    }
  };
  useEffect(() => {
    fetchRooms();
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  const [events, setEvents] = useState();
  const fetchEvents = async () => {
    try {
      setIsLoading(true);

      let fetchedEvents = [];

      const q = query(collection(db, "events"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newEvent = doc.data();

        fetchedEvents.push(newEvent);
      });

      setEvents(fetchedEvents);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching events");
    }
  };
  useEffect(() => {
    fetchEvents();
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  const [mainNewsArticle, setMainNewsArticle] = useState();
  const [primaryNewsArticles, setPrimaryNewsArticles] = useState();
  const [secondaryNewsArticles, setSecondaryNewsArticles] = useState();
  const fetchNewsArticles = async () => {
    try {
      setIsLoading(true);

      let fetchedMainArticle;
      let fetchedPrimaryArticles = [];
      let fetchedSecondaryArticles = [];

      const q = query(collection(db, "newsArticles"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newArticle = doc.data();
        if (newArticle.type === "main") {
          fetchedMainArticle = newArticle;
        } else if (newArticle.type === "primary") {
          fetchedPrimaryArticles.push(newArticle);
        } else if (newArticle.type === "secondary") {
          fetchedSecondaryArticles.push(newArticle);
        }
      });

      setMainNewsArticle(fetchedMainArticle);
      setPrimaryNewsArticles(fetchedPrimaryArticles);
      setSecondaryNewsArticles(fetchedSecondaryArticles);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching news articles");
    }
  };
  useEffect(() => {
    if (user) {
      fetchNewsArticles();
    }
    // eslint-disable-next-line
  }, [user]);

  // Format as dd.mm.yyyy (handles strings like '2025-10-28T00:00')
  const formatDateShort = (dateTime) => {
    try {
      if (!dateTime) return "";
      // If it's a Firestore Timestamp-like object with toDate()
      let d = null;
      if (
        typeof dateTime === "object" &&
        dateTime !== null &&
        typeof dateTime.toDate === "function"
      ) {
        d = dateTime.toDate();
      } else if (
        typeof dateTime === "object" &&
        dateTime !== null &&
        typeof dateTime.seconds === "number"
      ) {
        d = new Date(dateTime.seconds * 1000);
      } else if (typeof dateTime === "string") {
        // Prefer extracting YYYY-MM-DD to avoid timezone shifts
        const m = dateTime.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return `${m[3]}.${m[2]}.${m[1]}`;
        d = new Date(dateTime);
      } else {
        d = new Date(dateTime);
      }
      if (!d || isNaN(d.getTime())) return "";
      const dd = String(d.getDate()).padStart(2, "0");
      const mm = String(d.getMonth() + 1).padStart(2, "0");
      const yyyy = d.getFullYear();
      return `${dd}.${mm}.${yyyy}`;
    } catch (e) {
      return "";
    }
  };

  // eslint-disable-next-line
  const groupsTableColumns = [
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "sport",
      headerName: "Sport",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "league",
      headerName: "League",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "tournament",
      headerName: "Tournament",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
      valueGetter: (value, row) => {
        // Support both new 'tournament' and legacy 'season' field
        return row?.tournament || row?.season || "";
      },
    },
    {
      field: "openingDateTime",
      headerName: "Opening",
      valueFormatter: (params) => {
        try {
          // Support two shapes: DataGrid may pass a params object with .row, or it may pass the raw value directly.
          // If `params` is the raw value (string like "2025-10-28T00:00"), use it directly.
          const val =
            params && params.row ? params.row.openingDateTime : params;
          return formatDateShort(val);
        } catch (e) {
          return "";
        }
      },
      flex: 1,
      minWidth: 200,
      maxWidth: 250,
    },
    {
      field: "closingDateTime",
      headerName: "Closing",
      valueFormatter: (params) => {
        try {
          const val =
            params && params.row ? params.row.closingDateTime : params;
          return formatDateShort(val);
        } catch (e) {
          return "";
        }
      },
      flex: 1,
      minWidth: 200,
      maxWidth: 250,
    },
    {
      field: "results",
      headerName: "Results",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
  ];

  const handleGroupClick = (params) => {
    navigate(`groups/${params.row.uid}`);
  };

  // eslint-disable-next-line
  const roomsTableColumns = [
    {
      field: "leagueSport",
      headerName: "Sport",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "leagueName",
      headerName: "League",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "season",
      headerName: "Season",
      flex: 1,
      minWidth: 150,
      maxWidth: 200,
    },
    {
      field: "tournamentType",
      headerName: "Tournament Type",
      flex: 1,
      minWidth: 140,
      maxWidth: 180,
      valueFormatter: (params) => {
        // Map known keys to friendly labels
        const key = String(params || "").trim();
        const labelMap = {
          casual: "Casual",
          standard: "Standard",
          highStakes: "High Stakes",
          vipExclusive: "VIP Exclusive",
          vipexclusive: "VIP Exclusive",
          highstakes: "High Stakes",
        };
        if (labelMap[key]) return labelMap[key];
        // fallback: convert camelCase or other keys into title-cased words
        const spaced = String(key)
          .replace(/([a-z])([A-Z])/g, "$1 $2")
          .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
        return spaced
          .split(" ")
          .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
          .join(" ");
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 100,
      maxWidth: 125,
      valueGetter: (value, row) => {
        if (row.groupKey) {
          // For grouped rows
          if (row.allActive) return "All Active";
          if (row.allInactive) return "All Closed";
          return "Mixed";
        }
        return row.isActive ? "Active" : "Inactive";
      },
    },
    {
      field: "durationType",
      headerName: "Duration",
      flex: 1,
      minWidth: 120,
      maxWidth: 140,
      valueFormatter: (params) => {
        try {
          const row = params && params.row ? params.row : {};
          const d = row.durationType || "monthly";
          return String(d).toUpperCase();
        } catch (e) {
          return "MONTHLY";
        }
      },
    },
    {
      field: "memberCount",
      headerName: "Members",
      flex: 1,
      minWidth: 100,
      maxWidth: 150,
      valueGetter: (value, row) => {
        return row.totalMembers !== undefined
          ? row.totalMembers
          : row.memberCount || 0;
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 180,
      maxWidth: 200,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (params.row.groupKey && params.row.allActive) {
          // Show bulk close button for grouped rows that have active tournaments
          return (
            <Button
              size="sm"
              color="danger"
              onClick={(e) => {
                e.stopPropagation();
                closeAllTournamentTypes(params.row);
              }}
            >
              Close All Types
            </Button>
          );
        }
        return null;
      },
    },
  ];

  // Group tournaments by league + season and flatten for tree display
  const flattenedRoomsData = useMemo(() => {
    if (!rooms) return [];

    const grouped = {};
    rooms.forEach((room) => {
      const key = `${room.leagueName || "Unknown"}|${room.season || "Unknown"}`;
      if (!grouped[key]) {
        grouped[key] = {
          groupKey: key,
          uid: key, // Use groupKey as uid for DataGrid
          leagueName: room.leagueName,
          season: room.season,
          leagueSport: room.leagueSport,
          openingDateTime: room.openingDateTime,
          closingDateTime: room.closingDateTime,
          durationType: room.durationType,
          rooms: [],
          totalMembers: 0,
          allActive: true,
          allInactive: true,
          hierarchy: [],
        };
      }
      grouped[key].rooms.push(room);
      grouped[key].totalMembers += room.memberCount || 0;
      if (!room.isActive) grouped[key].allActive = false;
      if (room.isActive) grouped[key].allInactive = false;
    });

    // Create flattened array with parent and child rows
    const flattened = [];
    Object.values(grouped)
      .sort((a, b) => new Date(b.openingDateTime) - new Date(a.openingDateTime))
      .forEach((group) => {
        // Add parent row
        flattened.push({
          ...group,
          hierarchy: [group.groupKey],
        });
        // Add child rows (individual tournament types)
        group.rooms.forEach((room) => {
          flattened.push({
            ...room,
            hierarchy: [group.groupKey, room.uid],
            parentKey: group.groupKey,
          });
        });
      });

    return flattened;
  }, [rooms]);

  // Helper function to determine entry fee based on tournament type and duration
  const getEntryFee = (tournamentType, durationType) => {
    const type = (tournamentType || "casual").toLowerCase();
    const duration = (durationType || "monthly").toLowerCase();

    const ENTRY_FEES = {
      casual: { monthly: 300, weekly: 100 },
      standard: { monthly: 550, weekly: 200 },
      highstakes: { monthly: 1100, weekly: 300 },
      vipexclusive: { monthly: 2000, weekly: 2000 },
    };

    return ENTRY_FEES[type]?.[duration] || ENTRY_FEES.casual.monthly;
  };

  const closeAllTournamentTypes = async (group) => {
    const result = await Swal.fire({
      title: "Close All Tournament Types?",
      html: `Are you sure you want to close all tournament types for:<br/><strong>${group.leagueName} - ${group.season}</strong>?<br/><br/>This will close: Casual, Standard, High Stakes, and VIP Exclusive tournaments.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      confirmButtonText: "YES, CLOSE ALL",
      cancelButtonText: "CANCEL",
    });

    if (!result.isConfirmed) return;

    try {
      setIsLoading(true);

      // Close all rooms in this group and handle refunds/prizes
      for (const room of group.rooms) {
        if (room.isActive) {
          const roomRef = query(
            collection(db, "rooms"),
            where("uid", "==", room.uid)
          );
          const findRooms = await getDocs(roomRef);
          for (const roomDoc of findRooms.docs) {
            const getRoomDoc = doc(db, "rooms", roomDoc.id);
            const roomData = roomDoc.data();

            // Close the room
            await updateDoc(getRoomDoc, {
              isActive: false,
            });

            // Check if tournament has less than 10 participants - if so, refund entry fees
            const members = roomData.members || [];
            if (members.length < 10) {
              const entryFee = getEntryFee(
                roomData.tournamentType,
                roomData.durationType
              );

              // Refund all participants
              for (const member of members) {
                try {
                  const userRef = query(
                    collection(db, "users"),
                    where("uid", "==", member.uid)
                  );
                  const findUser = await getDocs(userRef);
                  if (!findUser.docs.length) continue;
                  const userDoc = findUser.docs[0];
                  const userData = userDoc.data();
                  const previousTickets = Number(userData.tickets || 0);
                  const newTickets = previousTickets + entryFee;

                  // update user's tickets with refund
                  const getUserDoc = doc(db, "users", userDoc.id);
                  await updateDoc(getUserDoc, {
                    tickets: newTickets,
                  });

                  // write wallet transaction audit for the refund
                  try {
                    await addDoc(collection(db, "wallet_transactions"), {
                      userUid: member.uid,
                      change: entryFee,
                      currency: "tickets",
                      reason: "tournament_refund_minimum_not_met",
                      tournamentUid: room.uid,
                      tournamentSeason: roomData.season || null,
                      tournamentType: roomData.tournamentType || null,
                      durationType: roomData.durationType || null,
                      previousBalance: previousTickets,
                      newBalance: newTickets,
                      timestamp: new Date(),
                    });
                  } catch (auditErr) {
                    console.error(
                      "Failed to write wallet transaction audit for refund:",
                      auditErr
                    );
                  }
                } catch (e) {
                  console.error("Failed to refund member:", e);
                }
              }

              // Create an admin-facing audit record for the refund
              try {
                await addDoc(collection(db, "audit_tournament_refunds"), {
                  tournamentUid: room.uid,
                  tournamentSeason: roomData.season || null,
                  tournamentType: roomData.tournamentType || null,
                  durationType: roomData.durationType || null,
                  league: roomData.leagueName || null,
                  refundedAt: new Date(),
                  participantCount: members.length,
                  reason: "minimum_participants_not_met",
                  refundAmount: entryFee,
                  totalRefunded: members.length * entryFee,
                  participants: members.map((m) => ({
                    uid: m.uid,
                    name: m.name,
                    refundAmount: entryFee,
                  })),
                });
              } catch (auditErr) {
                console.error(
                  "Failed to write tournament refund audit:",
                  auditErr
                );
              }
            }
          }
        }
      }

      await Swal.fire({
        title: "Success!",
        text: `All tournament types for ${group.leagueName} - ${group.season} have been closed.`,
        icon: "success",
        confirmButtonColor: "#005EE1",
      });

      // Refresh the rooms data
      await fetchRooms();
    } catch (error) {
      console.error("Error closing tournaments:", error);
      Swal.fire({
        title: "Error",
        text: "An error occurred while closing tournaments. Please try again.",
        icon: "error",
        confirmButtonColor: "#005EE1",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleRoomClick = (params) => {
    // If it's a grouped row, don't navigate
    if (params.row.groupKey) return;
    navigate(`tournaments/${params.row.uid}`);
  };

  const [leagues, setLeagues] = useState();
  const fetchLeagues = async () => {
    try {
      setIsLoading(true);

      let fetchedLeagues = [];

      const q = query(collection(db, "leagues"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newLeague = doc.data();

        fetchedLeagues.push(newLeague);
      });

      setLeagues(fetchedLeagues);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching leagues");
    }
  };

  useEffect(() => {
    fetchLeagues();
    // eslint-disable-next-line
  }, []);

  const leaguesTableColumns = [{ field: "name", headerName: "Name", flex: 1 }];

  const handleLeagueClick = (params) => {
    navigate(`leagues/${params.row.uid}`);
  };

  const [rewards, setRewards] = useState();
  const fetchRewards = async () => {
    try {
      setIsLoading(true);

      let fetchedRewards = [];

      const q = query(collection(db, "rewards"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newReward = doc.data();

        fetchedRewards.push(newReward);
      });

      setRewards(fetchedRewards);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching rewards");
    }
  };

  useEffect(() => {
    fetchRewards();
    // eslint-disable-next-line
  }, []);

  const rewardsTableColumns = [
    { field: "name", headerName: "Name", flex: 1 },
    { field: "priceInTickets", headerName: "Price", flex: 1, maxWidth: 110 },
  ];

  const handleRewardClick = (params) => {
    navigate(`rewards/${params.row.uid}`);
  };

  const [coupons, setCoupons] = useState();
  const fetchCoupons = async () => {
    try {
      setIsLoading(true);

      let fetchedCoupons = [];

      const q = query(collection(db, "discountCodes"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newCoupon = doc.data();

        fetchedCoupons.push(newCoupon);
      });

      setCoupons(fetchedCoupons);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching coupons");
    }
  };

  useEffect(() => {
    fetchCoupons();
    // eslint-disable-next-line
  }, []);

  const couponsTableColumns = [
    { field: "code", headerName: "Code", flex: 1, minWidth: 150 },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      minWidth: 100,
      maxWidth: 100,
    },
    {
      field: "value",
      headerName: "Value",
      flex: 1,
      minWidth: 110,
      maxWidth: 110,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 110,
      maxWidth: 110,
    },
  ];

  const handleCouponClick = (params) => {
    navigate(`coupons/${params.row.uid}`);
  };

  const [userSearchTerms, setUserSearchTerms] = useState();

  const [bundles, setBundles] = useState();

  const fetchBundles = async () => {
    try {
      setIsLoading(true);

      let fetchedBundles = [];

      const q = query(collection(db, "bundles"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newBundle = doc.data();

        fetchedBundles.push(newBundle);
      });

      setBundles(fetchedBundles);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching bundles");
    }
  };

  useEffect(() => {
    fetchBundles();

    // eslint-disable-next-line
  }, []);

  const [products, setProducts] = useState();

  const fetchProducts = async () => {
    try {
      setIsLoading(true);

      let fetchedProducts = [];

      const q = query(collection(db, "products"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newProduct = doc.data();

        fetchedProducts.push(newProduct);
      });

      setProducts(fetchedProducts);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching products");
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line
  }, []);

  const [banners, setBanners] = useState();

  const fetchBanners = async () => {
    try {
      setIsLoading(true);

      let fetchedBanners = [];

      const q = query(collection(db, "homePageBanners"));
      const docs = await getDocs(q);
      docs.forEach((doc) => {
        const newBanner = doc.data();

        fetchedBanners.push(newBanner);
      });

      setBanners(fetchedBanners);

      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching banners");
    }
  };

  useEffect(() => {
    fetchBanners();
    // eslint-disable-next-line
  }, []);

  const displayGroups = useMemo(() => {
    if (!groups) return [];
    const seen = new Map();
    const dedup = [];
    for (const g of groups) {
      // Build a stable identifier that groups variants of the same tournament together.
      // Use league + tournament (fallback season/name) + openingDateTime so types that only
      // differ by `tournamentType` will be collapsed.
      const nameKey = (g.name || g.tournament || g.season || "")
        .toString()
        .trim()
        .toLowerCase();
      const leagueKey = (g.league || "").toString().trim().toLowerCase();
      const identifier = `league:${leagueKey}|name:${nameKey}`;

      const existing = seen.get(identifier);
      if (!existing) {
        // First time seeing this group
        seen.set(identifier, g);
        dedup.push(g);
      } else {
        // We've seen this group before - replace it if the new one has season populated
        // and the existing one doesn't
        if (
          (g.season || g.tournament) &&
          !(existing.season || existing.tournament)
        ) {
          const index = dedup.indexOf(existing);
          if (index !== -1) {
            dedup[index] = g;
            seen.set(identifier, g);
          }
        }
      }
    }

    return dedup;
  }, [groups]);

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="adminPage" className="page">
      <h1>
        {/* <FaChevronLeft onClick={() => navigate(-1)} style={{color: '#005EE1', width: 35, height: 35, marginTop: -8, marginRight: '0.25rem', cursor: 'pointer'}}/> */}
        ADMIN
      </h1>
      <ScrollMenu>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "USERS",
          })}
          onClick={() => toggleActiveTab("USERS")}
        >
          <p>USERS ({users?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "GROUPS",
          })}
          onClick={() => toggleActiveTab("GROUPS")}
        >
          <p>GROUPS ({groups?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "TOURNAMENTS",
          })}
          onClick={() => toggleActiveTab("TOURNAMENTS")}
        >
          <p>TOURNAMENTS ({rooms?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "LEAGUES",
          })}
          onClick={() => toggleActiveTab("LEAGUES")}
        >
          <p>LEAGUES ({leagues?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "REWARDS",
          })}
          onClick={() => toggleActiveTab("REWARDS")}
        >
          <p>REWARDS ({rewards?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "COUPONS",
          })}
          onClick={() => toggleActiveTab("COUPONS")}
        >
          <p>COUPONS ({coupons?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "NEWS",
          })}
          onClick={() => toggleActiveTab("NEWS")}
        >
          <p>NEWS</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "BUNDLES",
          })}
          onClick={() => toggleActiveTab("BUNDLES")}
        >
          <p>BUNDLES ({bundles?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "PRODUCTS",
          })}
          onClick={() => toggleActiveTab("PRODUCTS")}
        >
          <p>PRODUCTS ({products?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "BANNERS",
          })}
          onClick={() => toggleActiveTab("BANNERS")}
        >
          <p>BANNERS ({banners?.length})</p>
        </div>
        <div
          className={classnames("shopCategoriesMenuItem", {
            active: activeTab === "REPORTS",
          })}
          onClick={() => toggleActiveTab("REPORTS")}
        >
          <p>REPORTS</p>
        </div>
      </ScrollMenu>
      <div style={{ marginTop: "1rem" }}>
        {!activeTab || activeTab === "USERS" ? (
          <div className="adminPageSection">
            {/* <h1>
                USERS
              </h1> */}
            <input
              type="text"
              className="mainInput"
              value={userSearchTerms}
              onChange={(e) => setUserSearchTerms(e.target.value)}
              placeholder="Search..."
              style={{ marginBottom: "0.5rem" }}
            />
            {userSearchTerms?.length > 0
              ? users
                  ?.filter((userObject) => {
                    return userObject?.username
                      ?.toLowerCase()
                      .includes(userSearchTerms.toLowerCase());
                  })
                  ?.map((userObject) => {
                    return (
                      <div
                        key={userObject?.uid}
                        onClick={() =>
                          navigate(`/admin/users/${userObject?.uid}`)
                        }
                        className="adminNewsArticle"
                      >
                        <p>{userObject?.username}</p>
                      </div>
                    );
                  })
              : users?.map((userObject) => {
                  return (
                    <div
                      key={userObject?.uid}
                      onClick={() =>
                        navigate(`/admin/users/${userObject?.uid}`)
                      }
                      className="adminNewsArticle"
                    >
                      <p>{userObject?.username}</p>
                    </div>
                  );
                })}
          </div>
        ) : null}
        {!activeTab || activeTab === "GROUPS" ? (
          <div className="adminPageSection">
            {/* <h1>
                EVENTS
              </h1> */}
            <a href="/admin/groups/create" className="primaryBtn">
              <Button className="primaryBtn" style={{ marginBottom: "1rem" }}>
                CREATE GROUP
              </Button>
            </a>
            <DataGridPro
              getRowId={(row) => row.uid}
              rows={displayGroups}
              columns={groupsTableColumns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 20, 30]}
              onRowClick={handleGroupClick}
              checkboxSelection={false}
              slots={{ toolbar: GridToolbar }}
              // disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
            {/* {
                groups?.length === 0 ?
                  <p style={{color: 'white', textAlign: 'center'}}>
                    No groups yet
                  </p>
                :
                  groups?.map(group => {
                    return (
                      <div onClick={() => navigate(`/admin/groups/${group?.uid}`)} className='adminNewsArticle'>
                        <p>
                          {group?.name}
                        </p>
                      </div>
                    )
                  })
              } */}
          </div>
        ) : null}
        {!activeTab || activeTab === "TOURNAMENTS" ? (
          <div className="adminPageSection">
            <a href="/admin/tournaments/create" className="primaryBtn">
              <Button className="primaryBtn" style={{ marginBottom: "1rem" }}>
                CREATE TOURNAMENT
              </Button>
            </a>
            <DataGridPro
              getRowId={(row) => row.uid}
              rows={flattenedRoomsData}
              columns={roomsTableColumns}
              treeData
              getTreeDataPath={(row) => row.hierarchy}
              groupingColDef={{
                headerName: "Tournament / Season",
                flex: 2,
                minWidth: 300,
                maxWidth: 500,
                valueGetter: (value, row) => {
                  // For parent rows (grouped), show the season
                  if (row.groupKey) {
                    return row.season || "";
                  }
                  // For child rows, show the tournament type
                  return row.tournamentType
                    ? {
                        casual: "Casual",
                        standard: "Standard",
                        highStakes: "High Stakes",
                        vipExclusive: "VIP Exclusive",
                        vipexclusive: "VIP Exclusive",
                        highstakes: "High Stakes",
                      }[row.tournamentType] || row.tournamentType
                    : "";
                },
              }}
              defaultGroupingExpansionDepth={0}
              columnVisibilityModel={{
                leagueSport: true,
                leagueName: true,
                season: false, // Hide the separate season column since it's in the grouping
                tournamentType: false, // Hide since it's in the grouping for child rows
              }}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 20, 30]}
              onRowClick={handleRoomClick}
              checkboxSelection={false}
              slots={{ toolbar: GridToolbar }}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
          </div>
        ) : null}
        {!activeTab || activeTab === "LEAGUES" ? (
          <div className="adminPageSection">
            <a href="/admin/leagues/create" className="primaryBtn">
              <Button className="primaryBtn" style={{ marginBottom: "1rem" }}>
                CREATE LEAGUE
              </Button>
            </a>
            <DataGridPro
              getRowId={(row) => row.uid}
              rows={leagues}
              columns={leaguesTableColumns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 20, 30]}
              onRowClick={handleLeagueClick}
              checkboxSelection={false}
              slots={{ toolbar: GridToolbar }}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
          </div>
        ) : null}
        {!activeTab || activeTab === "REWARDS" ? (
          <div className="adminPageSection">
            <a href="/admin/rewards/create" className="primaryBtn">
              <Button className="primaryBtn" style={{ marginBottom: "0.5rem" }}>
                CREATE REWARD
              </Button>
            </a>
            <a href="/admin/rewards/history" className="secondaryBtn">
              <Button className="secondaryBtn" style={{ marginBottom: "1rem" }}>
                REDEMPTION HISTORY
              </Button>
            </a>
            <DataGridPro
              getRowId={(row) => row.uid}
              rows={rewards}
              columns={rewardsTableColumns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 20, 30]}
              onRowClick={handleRewardClick}
              checkboxSelection={false}
              slots={{ toolbar: GridToolbar }}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
          </div>
        ) : null}
        {!activeTab || activeTab === "COUPONS" ? (
          <div className="adminPageSection">
            <a href="/admin/coupons/create" className="primaryBtn">
              <Button className="primaryBtn" style={{ marginBottom: "1rem" }}>
                CREATE COUPON
              </Button>
            </a>
            <DataGridPro
              getRowId={(row) => row.uid}
              rows={coupons}
              columns={couponsTableColumns}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 },
                },
              }}
              pageSizeOptions={[10, 20, 30]}
              onRowClick={handleCouponClick}
              checkboxSelection={false}
              slots={{ toolbar: GridToolbar }}
              disableColumnFilter
              disableColumnSelector
              disableDensitySelector
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
          </div>
        ) : null}
        {!activeTab || activeTab === "NEWS" ? (
          <div className="adminPageSection">
            {/* <h1>
                NEWS
              </h1> */}
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Main article
            </p>
            <div
              onClick={() =>
                navigate(`/admin/news/articles/${mainNewsArticle?.uid}`)
              }
              className="adminNewsArticle"
            >
              <p>{mainNewsArticle?.title}</p>
              <p>
                {new Date(mainNewsArticle?.dateCreated).toLocaleDateString(
                  "de-DE"
                )}
              </p>
            </div>
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Primary articles
            </p>
            {primaryNewsArticles?.length < 4 ? (
              <Button
                onClick={() => navigate("/admin/news/create-article/primary")}
                className="primaryBtn"
                style={{ marginBottom: "0.5rem" }}
              >
                CREATE NEW
              </Button>
            ) : null}
            {
              // eslint-disable-next-line
              primaryNewsArticles?.map((article) => {
                return (
                  <div
                    onClick={() =>
                      navigate(`/admin/news/articles/${article?.uid}`)
                    }
                    className="adminNewsArticle"
                  >
                    <p>{article?.title}</p>
                    <p>
                      {new Date(article?.dateCreated).toLocaleDateString(
                        "de-DE"
                      )}
                    </p>
                  </div>
                );
              })
            }
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Secondary articles
            </p>
            {secondaryNewsArticles?.length < 8 ? (
              <Button
                onClick={() => navigate("/admin/news/create-article/secondary")}
                className="primaryBtn"
                style={{ marginBottom: "0.5rem" }}
              >
                CREATE NEW
              </Button>
            ) : null}
            {
              // eslint-disable-next-line
              secondaryNewsArticles?.map((article) => {
                return (
                  <div
                    onClick={() =>
                      navigate(`/admin/news/articles/${article?.uid}`)
                    }
                    className="adminNewsArticle"
                  >
                    <p>{article?.title}</p>
                    <p>
                      {new Date(article?.dateCreated).toLocaleDateString(
                        "de-DE"
                      )}
                    </p>
                  </div>
                );
              })
            }
          </div>
        ) : null}
        {!activeTab || activeTab === "BUNDLES" ? (
          <div className="adminPageSection">
            <Button
              onClick={() => navigate("/admin/bundles/create")}
              className="primaryBtn"
              style={{ marginBottom: "0.5rem" }}
            >
              CREATE BUNDLE
            </Button>
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Active
            </p>
            {bundles?.filter((bundle) => bundle?.status === "Active")
              ?.length === 0 && (
              <p style={{ color: "white", textAlign: "center" }}>
                No active bundles
              </p>
            )}
            {
              // eslint-disable-next-line
              bundles?.map((bundle) => {
                if (bundle?.status === "Active") {
                  return (
                    <div
                      onClick={() => navigate(`/admin/bundles/${bundle?.uid}`)}
                      className="adminNewsArticle"
                    >
                      <p>{bundle?.name}</p>
                    </div>
                  );
                }
              })
            }
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Inactive
            </p>
            {bundles?.filter((bundle) => bundle?.status === "Inactive")
              ?.length === 0 && (
              <p style={{ color: "white", textAlign: "center" }}>
                No inactive bundles
              </p>
            )}
            {
              // eslint-disable-next-line
              bundles?.map((bundle) => {
                if (bundle?.status === "Inactive") {
                  return (
                    <div
                      onClick={() => navigate(`/admin/bundles/${bundle?.uid}`)}
                      className="adminNewsArticle"
                    >
                      <p>{bundle?.name}</p>
                    </div>
                  );
                }
              })
            }
          </div>
        ) : null}
        {!activeTab || activeTab === "PRODUCTS" ? (
          <div className="adminPageSection">
            <Button
              onClick={() => navigate("/admin/products/create")}
              className="primaryBtn"
              style={{ marginBottom: "0.5rem" }}
            >
              CREATE PRODUCT
            </Button>
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Active
            </p>
            {products?.filter(
              (product) =>
                (product?.category === "PROFILE BANNERS" ||
                  product?.category === "AVATAR ICONS") &&
                new Date(product?.activeFrom) < new Date() &&
                new Date(product?.activeTo) > new Date()
            )?.length === 0 ? (
              <p style={{ color: "white", textAlign: "center" }}>
                No active products
              </p>
            ) : (
              // eslint-disable-next-line
              products?.map((product) => {
                if (
                  (product?.category === "PROFILE BANNERS" ||
                    product?.category === "AVATAR ICONS") &&
                  new Date(product?.activeFrom) < new Date() &&
                  new Date(product?.activeTo) > new Date()
                ) {
                  return (
                    <div
                      onClick={() =>
                        navigate(`/admin/products/${product?.uid}`)
                      }
                      className="adminNewsArticle"
                    >
                      <p>
                        <span className="bundleProductCategory">
                          {product.category}
                        </span>
                        &nbsp;
                        <span className="bundleProductName">
                          {product.name}
                        </span>
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <p className="bundleProductPrice">${product.price}</p>
                      </div>
                    </div>
                  );
                }
              })
            )}
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Inactive
            </p>
            {products?.filter(
              (product) =>
                (product?.category === "PROFILE BANNERS" ||
                  product?.category === "AVATAR ICONS") &&
                (new Date(product?.activeFrom) > new Date() ||
                  new Date(product?.activeTo) < new Date())
            )?.length === 0 ? (
              <p style={{ color: "white", textAlign: "center" }}>
                No inactive products
              </p>
            ) : (
              // eslint-disable-next-line
              products?.map((product) => {
                if (
                  (product?.category === "PROFILE BANNERS" ||
                    product?.category === "AVATAR ICONS") &&
                  (new Date(product?.activeFrom) > new Date() ||
                    new Date(product?.activeTo) < new Date())
                ) {
                  return (
                    <div
                      onClick={() =>
                        navigate(`/admin/products/${product?.uid}`)
                      }
                      className="adminNewsArticle"
                    >
                      <p>
                        <span className="bundleProductCategory">
                          {product.category}
                        </span>
                        &nbsp;
                        <span className="bundleProductName">
                          {product.name}
                        </span>
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <p className="bundleProductPrice">${product.price}</p>
                      </div>
                    </div>
                  );
                }
              })
            )}
            <p className="inputLabel" style={{ color: "#FFFFFF" }}>
              Permanent
            </p>
            {
              // eslint-disable-next-line
              products?.map((product) => {
                if (
                  // ((product?.category === 'PROFILE BANNERS') || (product?.category === 'AVATAR ICONS')) &&
                  !product?.activeFrom &&
                  !product?.activeTo
                ) {
                  return (
                    <div
                      onClick={() =>
                        navigate(`/admin/products/${product?.uid}`)
                      }
                      className="adminNewsArticle"
                    >
                      <p>
                        <span className="bundleProductCategory">
                          {product.category}
                        </span>
                        &nbsp;
                        <span className="bundleProductName">
                          {product.name}
                        </span>
                      </p>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        <p className="bundleProductPrice">${product.price}</p>
                      </div>
                    </div>
                  );
                }
              })
            }
          </div>
        ) : null}
        {!activeTab || activeTab === "REPORTS" ? (
          <div className="adminPageSection">
            <div
              style={{
                display: "flex",
                flexDirection: "column",

                marginTop: 12,
              }}
            >
              <div
                onClick={() => navigate("/admin/wallet-transactions")}
                className="accountPageMenuItem"
                style={{ cursor: "pointer" }}
              >
                <p>WALLET TRANSACTIONS</p>
              </div>
              <div
                onClick={() => navigate("/admin/prize-distributions")}
                className="accountPageMenuItem"
                style={{ cursor: "pointer" }}
              >
                <p>PRIZE DISTRIBUTIONS</p>
              </div>
              <div
                onClick={() => navigate("/admin/rewards/history")}
                className="accountPageMenuItem"
                style={{ cursor: "pointer" }}
              >
                <p>REWARD REDEMPTIONS</p>
              </div>
            </div>
          </div>
        ) : null}
        {!activeTab || activeTab === "BANNERS" ? (
          <div className="adminPageSection">
            <Button
              onClick={() => navigate("/admin/banners/add")}
              className="primaryBtn"
              style={{ marginBottom: "0.5rem" }}
            >
              ADD BANNER
            </Button>
            {
              // eslint-disable-next-line
              banners?.map((banner) => {
                return (
                  <div
                    onClick={() => navigate(`/admin/banners/${banner?.uid}`)}
                    className="adminNewsArticle"
                  >
                    <p>{banner?.uid}</p>
                  </div>
                );
              })
            }
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default AdminPage;
